// Confirmación de la toma automática (PLAN C11.5): «Este paciente está en la Sala de la Dra./Dr. A. ¿Atenderlo tú?». Evita cobros cruzados: el servidor no
// cambia el dueño del turno hasta que este médico lo confirma.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export type TomaPendiente = { deMedico: string | null; especialidadDistinta: boolean };

export function ConfirmarTomaDialog({
  toma,
  ocupado,
  onConfirmar,
  onCancelar,
}: {
  toma: TomaPendiente | null;
  ocupado: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <Dialog open={toma !== null} onOpenChange={(abierto) => !abierto && onCancelar()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('sala.toma.titulo')}</DialogTitle>
          <DialogDescription>{toma?.deMedico ? t('sala.toma.texto', { medico: toma.deMedico }) : t('sala.toma.textoSinMedico')}</DialogDescription>
        </DialogHeader>
        {toma?.especialidadDistinta && <p className="text-sm text-amber-800">{t('sala.toma.otraEspecialidad', { medico: toma.deMedico ?? '—' })}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={onCancelar} disabled={ocupado}>
            {t('sala.confirmar.volver')}
          </Button>
          <Button onClick={onConfirmar} disabled={ocupado}>
            {t('sala.toma.confirmar')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
